import Vue from 'vue'
import Vuex from 'vuex'
import {getAgentInfo} from "@/api/login";
// 应用vuex插件
Vue.use(Vuex)

// 创建并暴露store
export default new Vuex.Store({
    // 数据,相当于data
    state: {
        token: null,
        userInfo: {},
        cooperatorId: null,
        userId: null,
        loginUser: null,
        cashNum: null
    },
    //准备getters——用于将state中的数据进行加工
    getters: {

    },
    //准备mutations——用于操作数据（state）
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token
        },
        SET_LOGIN_USER(state, loginUser) {
            state.loginUser = loginUser
        },
        LOGOUT(state) {
            state.token = null
        },
        SET_USER_INFO(state, userInfo) {
            state.userInfo = userInfo
        },
        SET_COOPERATOR_ID(state, cooperatorId) {
            state.cooperatorId = cooperatorId
        },
        SET_USER_ID(state, userId) {
            state.userId = userId
        },
        SET_CASH_NUM(state, cashNum) {
            state.cashNum = cashNum
        },

    },
    //准备actions——用于响应组件中的动作
    actions: {
        async getUserInfo({ commit }) {
            await getAgentInfo().then(res => {
                console.log(res, 'res-getAgentInfo');
                let userInfo = res.data;
                commit('SET_USER_INFO', userInfo);
            }).catch(err => {
                throw new Error('获取用户信息失败');
            })
        },
        async logout({ commit }) {
            commit('LOGOUT');
        }
    },
    modules: {
        GET_TOKEN: state => {
            return state.token
        },
        GET_USER_INFO: state => {
            return state.userInfo
        }
    }
})
